"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
/**
 * @param  {any} state
 * @returns void
 * Derive progressMeasure based on latest submission's
 * submissionStatus
 */
function updateProgressMeasureForCheckpoint(state) {
    const lastSubmission = state.submissions[0];
    if (lastSubmission) {
        switch (lastSubmission.submissionStatus) {
            case entity_1.CheckpointSubmissionStatus.NOT_ATTEMPTED:
                state.progressMeasure = 0;
                break;
            default:
                state.progressMeasure = 1;
                break;
        }
    }
    else {
        state.progressMeasure = 0;
    }
}
exports.updateProgressMeasureForCheckpoint = updateProgressMeasureForCheckpoint;
//# sourceMappingURL=updateProgressMeasureForCheckpoint.js.map